var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-box"},[(_vm.icon)?_c('img',{staticClass:"errorImg",attrs:{"src":require('@/assets/' + _vm.icon + '.svg')}}):_vm._e(),_c('div',[_vm._v(" "+_vm._s(_vm.msg)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }